import { Box } from "@mui/material";
import { BulkCreateExercisesTable, ExercisesTable } from "../../components";

export const ExercisesTab = () => {
  return (
    <Box sx={{ display: "flex", gap: 3, p: 3, backgroundColor: "#f5f5f5", flex: 1, overflow: "hidden" }}>
      <Box sx={{ flex: 3, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <BulkCreateExercisesTable />
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <ExercisesTable />
      </Box>
    </Box>
  );
};
